import { getRequestData } from '../../Utility/apiHelper';
import * as actionTyoes from './type';

export const handleRequestGetAllLookup = (authToken, currentClientId) => async(dispatch) => {

    try {


        const url = currentClientId ? `lookup?clientId=${currentClientId}` : `lookup`


        const response = await getRequestData(url);

        const { data } = response;
        dispatch({
            type: actionTyoes?.RECEIVED_GET_ALL_LOOKUP_DATA,
            payload: data
        })

    } catch(error) {

    }
}


export const handleRequestGetLookup = (authToken) => async(dispatch) => {
        
    try {


        const url = `${process.env.REACT_APP_LOOKUP_URL}lookup`;

        const response = await getRequestData(url);
        const {data} = response;

        dispatch({
            type: actionTyoes?.RECEIVED_ALL_LOOKUP_DATA,
            payload: data
        })

    } catch(error) {

    }

}



export const handleRequestGetAllSystemLookup = () => async(dispatch) => {

    try {

    } catch(error) {

    }
}



export const handleRequestCreateLookup = () => async(dispatch) => {

    try {

    } catch(error) {

    }
}


export const handleRequestDeleteLookup = () => async(dispatch) => {

    try {

    } catch(error) {

    }
}


export const handleRequestUpdateLookup = () => async(dispatch) => {

    try {

    } catch(error) {

    }
}


